
import { i18nText } from '@/locales';
import {RouterNameEnum} from "@/router/router.types";

const salonTabs = [
    {
        id: RouterNameEnum.SalonDetailCommon,
        name: i18nText("Общее")
    },
    {
        id: RouterNameEnum.SalonDetailFinancePage,
        name: i18nText("Финансы")
    },
    // {
    //     id: RouterNameEnum.SalonDetailReports,
    //     name: 'Отчеты'
    // },
    {
        id: RouterNameEnum.SalonDetailClientsPage,
        name: i18nText("Клиенты")
    },
    {
        id: RouterNameEnum.SalonDetailWorkers,
        name: i18nText("Сотрудники")
    },
    /*{
        id: RouterNameEnum.SalonDetailPhoto,
        name: 'Фото'
    },
    {
        id: RouterNameEnum.SalonDetailDocs,
        name: 'Документы'
    },
    {
        id: RouterNameEnum.SalonDetailAllow,
        name: 'Доступы'
    },*/
]
const loyaltyBonusTabs = [
    {
        id: RouterNameEnum.LoyaltyBonus,
        name: i18nText("Бонусная программа")
    },
    {
        id: RouterNameEnum.LoyaltyBonusType,
        name: i18nText("Типы бонусных программ")
    }
];

const loyaltyCertTabs = [
    {
        id: RouterNameEnum.LoyaltyCert,
        name: i18nText("Сертификаты")
    },
    {
        id: RouterNameEnum.LoyaltyCertType,
        name: i18nText("Типы сертификатов")
    },

];
const servicesTabs = [
    {
        id: RouterNameEnum.Services,
        name: i18nText("Услуги")
    },
    {
        id: RouterNameEnum.PartnerServices,
        name: i18nText("Услуги партнеров")
    }
];

const loyaltySubscriptionTabs = [
    {
        id: RouterNameEnum.LoyaltySubscription,
        name: i18nText("Абонементы")
    },
    {
        id: RouterNameEnum.LoyaltySubscriptionType,
        name: i18nText("Типы абонементов")
    }
];
const workerTabs = [
    {
        id: 0,
        name: i18nText("Записи"),
        component: 'WorkerNotes'
    },
    // {
    //     id: 1,
    //     name: 'Задачи',
    //     component: 'WorkerTasks'
    // },
    {
        id: 2,
        name: i18nText("График работы"),
        component: 'WorkerSchedule'
    },
    // {
    //     id: 3,
    //     name: 'Услуги',
    //     component: 'WorkerServices'
    // },
    // {
    //     id: 4,
    //     name: 'Файлы',
    //     component: 'WorkerDocs'
    // },
]
const clientTabs = [
    {
        id: RouterNameEnum.ClientDetailCommon,
        name: i18nText("Общее")
    },
    {
        id: RouterNameEnum.ClientDetailHistoryPage,
        name: i18nText("История посещений")
    },
    {
        id: RouterNameEnum.ClientDetailNotesPage,
        name: i18nText("Записи")
    },
    {
        id: RouterNameEnum.ClientDetailTasksPage,
        name: i18nText("Задачи")
    },
    {
        id: RouterNameEnum.ClientDetailDocumentsPage,
        name: i18nText("Документы")
    },
    {
        id: RouterNameEnum.ClientDetailPhotoPage,
        name: i18nText("Фото")
    },
    {
        id: RouterNameEnum.ClientDetailContraindicationsPage,
        name: i18nText("Противопоказания")
    },
    {
        id: RouterNameEnum.ClientDetailLoyaltyPage,
        name: i18nText("Лояльность")
    },
    {
        id: RouterNameEnum.ClientAccounts,
        name: i18nText("Счет клиента")
    }
];
const serviceCreateTabs = [
    {
        id: RouterNameEnum.ServicesCreationCosmetologists,
        name: i18nText("Косметологи")
    },
    {
        id: RouterNameEnum.ServicesCreationConsumables,
        name: i18nText("Расходники")
    },
    {
        id: RouterNameEnum.ServicesCreationDocuments,
        name: i18nText("Документы")
    },
    {
        id: RouterNameEnum.ServicesCreationAnamnez,
        name: i18nText("Анамнез")
    },
    {
        id: RouterNameEnum.ServicesCreationAlgoritm,
        name: i18nText("Алгоритм проведения")
    },
];
const serviceTabs = [
    {
        id: RouterNameEnum.ServiceDetailWorkers,
        name: i18nText("Сотрудники")
    },
    {
        id: RouterNameEnum.ServiceDetailProducts,
        name: i18nText("Расходники")
    },
    {
        id: RouterNameEnum.ServiceDetailDocuments,
        name: i18nText("Документы")
    },
    {
        id: RouterNameEnum.ServiceDetailAnamnez,
        name: i18nText("Анамнез")
    },

];
export {
    salonTabs,
    loyaltyBonusTabs,
    loyaltyCertTabs,
    loyaltySubscriptionTabs,
    workerTabs,
    clientTabs,
    serviceCreateTabs,
    serviceTabs,
    servicesTabs,
}
